import { ReactElement } from 'react';
import { renderFormItem } from './render-form-item';
import { FormConfig, RenderOptions } from './types';

export function renderForm(formConfig: FormConfig, renderOptions?: RenderOptions): ReactElement | null {
	return renderFormItem('root', formConfig, renderOptions);
}
